import { render } from "./ContributionCategory.vue?vue&type=template&id=667052bd&scoped=true"
import script from "./ContributionCategory.vue?vue&type=script&lang=js"
export * from "./ContributionCategory.vue?vue&type=script&lang=js"

import "./ContributionCategory.vue?vue&type=style&index=0&id=667052bd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667052bd"]])

export default __exports__